import {
  LINKEDIN_COUNTRIES,
  LINKEDIN_INDUSTRY_CODES
} from "~/constants/marketing-os"
import { getLocationDisplay } from "~/utils/location-helpers"

const SENIORITY_OPTIONS = [
  { labelKey: "people_list.seniority_owner", value: "owner" },
  { labelKey: "people_list.seniority_founder", value: "founder" },
  { labelKey: "people_list.seniority_c_suite", value: "c_suite" },
  { labelKey: "people_list.seniority_partner", value: "partner" },
  { labelKey: "people_list.seniority_vp", value: "vp" },
  { labelKey: "people_list.seniority_head", value: "head" },
  { labelKey: "people_list.seniority_director", value: "director" },
  { labelKey: "people_list.seniority_manager", value: "manager" },
  { labelKey: "people_list.seniority_senior", value: "senior" }
] as const

export const industryOptions = [
  {
    label: "All",
    value: "all",
    key: "all"
  },
  ...LINKEDIN_INDUSTRY_CODES.map((item) => ({
    label: item,
    value: item,
    key: item
  }))
]

export const getLocationOptions = (t: (key: string) => string) => [
  {
    label: t("label_all"),
    value: "all"
  },
  ...LINKEDIN_COUNTRIES.map((item) => ({
    label:
      t(`marketing_os.${item.labelKey}`) ||
      getLocationDisplay(item.value) ||
      item.label,
    value: item.value
  }))
]

export const REVENUE = {
  "1 - 200": "1MM - 200MM",
  "200 - 1000": "200MM - 1B",
  "1000 - 5000": "1B- 5B",
  "5000 - 20000": "5B - 20B",
  "20000": "20B+",
  NA: "Not available"
}

export const revenueOptions = [
  {
    label: "All",
    value: "all",
    key: "all"
  },
  {
    label: "1MM - 200MM",
    value: "1 - 200"
  },
  {
    label: "200MM - 1B",
    value: "200 - 1000"
  },
  {
    label: "1B- 5B",
    value: "1000 - 5000"
  },
  {
    label: "5B - 20B",
    value: "5000 - 20000"
  },
  {
    label: "20B+",
    value: "20000"
  },
  {
    label: "Revenue not available",
    value: "unknown",
    key: "unknown"
  }
]

export const employeeOptions = [
  {
    label: "All",
    value: "all",
    key: "all"
  },
  {
    label: "1-100",
    value: "1-100"
  },
  {
    label: "101-500",
    value: "101-500"
  },
  {
    label: "501-1000",
    value: "501-1000"
  },
  {
    label: "1001-5000",
    value: "1001-5000"
  },
  {
    label: "5001-10000",
    value: "5001-10000"
  },
  {
    label: "10001+",
    value: "10001+"
  }
]

export const getSeniorityOptions = (t: (key: string) => string) => [
  {
    label: t("label_all"),
    value: "all"
  },
  ...SENIORITY_OPTIONS.map((item) => ({
    label: t(item.labelKey),
    value: item.value
  }))
]
export const EVENTS = {
  IMPORT_PEOPLE_TO_LIST_MODAL_CLOSED: "import_people_to_list_modal_closed",
  IMPORT_PEOPLE_TO_LIST_SAMPLE_DOWNLOAD_CLICKED:
    "import_people_to_list_sample_download_clicked",
  MOBILE_NUMBER_DELETE: "marketing_os_mobile_number_deleted",
  MOBILE_NUMBER_EDIT: "marketing_os_mobile_number_edited",
  MOBILE_NUMBER_ADD: "marketing_os_mobile_number_added",
  MOBILE_NUMBER_COPY: "marketing_os_mobile_number_copied",
  MOBILE_NUMBER_FETCH: "marketing_os_mobile_number_fetch",
  CAMPAIGN_BACK_CLICKED: "marketing_os_campaign_back_clicked",
  CAMPAIGN_PRIORITY_CONTEXT_OPENED:
    "marketing_os_campaign_priority_context_opened",
  CAMPAIGN_PRIORITY_CONTEXT_CLOSED:
    "marketing_os_campaign_priority_context_closed",
  CAMPAIGN_SAVE_CLICKED: "marketing_os_campaign_save_clicked",
  CAMPAIGN_SAVE_SKIPPED: "marketing_os_campaign_save_skipped",
  EMAIL_FETCH_CLICKED: "marketing_os_email_fetch_clicked",
  EMAIL_COPY_CLICKED: "marketing_os_email_copy_clicked",
  EMAIL_EDIT_CLICKED: "marketing_os_email_edit_clicked",
  EMAIL_EDIT_CANCELLED: "marketing_os_email_edit_cancelled",
  EMAIL_DELETE_CLICKED: "marketing_os_email_delete_clicked",
  EMAIL_ADD_CLICKED: "marketing_os_email_add_clicked",
  EMAIL_ADD_CANCELLED: "marketing_os_email_add_cancelled",
  ACCOUNT_MODAL_CLOSED: "marketing_os_account_modal_closed",
  CALL_LOG_DETAILS_CLOSED: "marketing_os_call_log_details_closed",
  CALL_LOG_NOTES_TOGGLED: "marketing_os_call_log_notes_toggled",
  CALL_LOG_NOTE_DELETED: "marketing_os_call_log_note_deleted",
  CALLER_MODAL_CLOSED: "marketing_os_caller_modal_closed",
  CALLER_NOTES_TOGGLED: "marketing_os_caller_notes_toggled",
  CALLER_REDIAL_CLICKED: "marketing_os_caller_redial_clicked",
  CALLER_DISCONNECT_CLICKED: "marketing_os_caller_disconnect_clicked",
  CALLER_NOTE_DELETED: "marketing_os_caller_note_deleted",
  IMPORT_PEOPLE_TO_LIST_CLICKED: "marketing_os_import_people_to_list_clicked",
  OPPORTUNITIES_MODAL_CLOSED: "marketing_os_opportunities_modal_closed",
  OPPORTUNITY_VIEW_CLICKED: "marketing_os_opportunity_view_clicked",
  PERSON_MODAL_CLOSED: "marketing_os_person_modal_closed",
  PERSON_MESSAGE_TEMPLATE_CLICKED:
    "marketing_os_person_message_template_clicked",
  PERSON_BRIEF_OPENED: "marketing_os_person_brief_opened",
  PERSON_ADD_TO_LIST_CLICKED: "marketing_os_person_add_to_list_clicked",
  QUICK_SEARCH_CLEAR_CLICKED: "marketing_os_quick_search_clear_clicked",
  QUICK_SEARCH_CLOSED: "marketing_os_quick_search_closed",
  QUICK_SEARCH_PERSON_SELECTED: "marketing_os_quick_search_person_selected",
  QUICK_SEARCH_SHOW_ALL_PEOPLE_CLICKED:
    "marketing_os_quick_search_show_all_people_clicked",
  QUICK_SEARCH_ACCOUNT_SELECTED: "marketing_os_quick_search_account_selected",
  QUICK_SEARCH_SHOW_ALL_ACCOUNTS_CLICKED:
    "marketing_os_quick_search_show_all_accounts_clicked",
  QUICK_SEARCH_VIEW_KEY_PEOPLE_CLICKED:
    "marketing_os_quick_search_view_key_people_clicked",
  SEARCH_THEME_RESULT_SELECTED: "marketing_os_search_theme_result_selected",
  SEARCH_THEME_SELECTION_CLEARED: "marketing_os_search_theme_selection_cleared",
  SEARCH_THEME_VIEW_KEY_PEOPLE_CLICKED:
    "marketing_os_search_theme_view_key_people_clicked",
  SEARCH_THEME_DOWNLOAD_LIST_CLICKED:
    "marketing_os_search_theme_download_list_clicked",
  SEARCH_THEME_TAB_SELECTED: "marketing_os_search_theme_tab_selected",
  SIDEBAR_TOGGLED: "marketing_os_sidebar_toggled"
}
